// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz
// bxyz-widget: blurred gradient widgets för text och länkar

class BXYZWidget {
  constructor(container) {
    this.container = container;
    this.widgets = container.querySelectorAll('.bxyz-widget__item');
    
    this.init();
  }
  
  init() {
    this.setupHoverEffects();
    this.setupLinkHandling();
  }
  
  setupHoverEffects() {
    this.widgets.forEach((widget) => {
      widget.addEventListener('mouseenter', () => {
        widget.classList.add('hovered');
      });
      
      widget.addEventListener('mouseleave', () => {
        widget.classList.remove('hovered');
      });
    });
  }
  
  setupLinkHandling() {
    this.widgets.forEach((widget) => {
      const link = widget.dataset.link;
      if (link) {
        widget.style.cursor = 'pointer';
        widget.addEventListener('click', () => {
          window.location.href = link;
        });
      }
    });
  }
}

// initialisera
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.bxyz-widget');
  containers.forEach((container) => {
    new BXYZWidget(container);
  });
});
